import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';
import { Funding } from '@finley-technologies/finley-types';

import { Typography } from '~/packages/common-frontend/components/Typography';

type MaturityType = Funding.LoanMechanics['loans'][number]['maturity'];

type MaturityProps = {
  maturity: MaturityType;
};

export const Maturity = ({ maturity }: MaturityProps) => {
  return (
    <>
      <Typography variant="section-subtitle">Maturity</Typography>
      <TableContainer w="100%">
        <Table borderWidth="1px">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Value</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>Type</Td>
              <Td>{commonUtils.toTitleCase(maturity.type)}</Td>
            </Tr>
            <Tr>
              <Td>Count</Td>
              <Td>{maturity.count}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
